import { FormBase } from 'core/components';

export default class BulkEmrModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'emr',
                    label: 'FACILITY.EDIT.EMR_LABEL',
                    placeholder: 'FACILITY.EDIT.EMR_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                // {
                //     name: 'emrAccountName',
                //     label: 'FACILITY.EDIT.EMR_ACCOUNT_NAME_LABEL',
                //     placeholder: 'FACILITY.EDIT.EMR_ACCOUNT_NAME_PLACEHOLDER',
                //     type: 'textarea',
                //     rules: 'string'
                // },
                {
                    name: 'emrUserName',
                    label: 'FACILITY.EDIT.EMR_USERNAME_LABEL',
                    placeholder: 'FACILITY.EDIT.EMR_USERNAME_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'emrPassword',
                    label: 'FACILITY.EDIT.EMR_PASSWORD_LABEL',
                    placeholder: 'FACILITY.EDIT.EMR_PASSWORD_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
            ],
        };
    }
}
